// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__31_cK","unreadBadge":"styles_unreadBadge__1tPWi","modalContent":"styles_modalContent__38Au2","modal":"styles_modal__1Bj8T"};